import LeftArrowTopHeader from "../../../newComponents/form-fields/LeftArrowTopHeader";
import { GetImages } from "../../../utils/GetImages";
import { TextCss } from "../../GlobalCss/TextCss";
import "./OrganizationnameHeader.css";

const OrganizationNameHeader = ({
  SubHeaderName,
  OrgName,
  OrgImg = GetImages.HomeBlackFilled,
  element = undefined,
  headerNameClass = "top_header_700_24 fw-normal grey_subtext1",
  subHeaderNameClass = "grey_subtext1 org-card-sub-heading",
  status = null,
  statusClass = null,
  statusElement = null,
  Goback = undefined,
  title = "",
  backPath = "",
  showDivider = true,
}) => {
  return (
    <>
      <div className="organization-header">
        <div className="onboardtopbar_left">
          {Goback && (
            <LeftArrowTopHeader
              className={TextCss.black.heading_700_16}
              title={title}
              backPath={backPath}
              handleSubmit={Goback}
            />
          )}
          <div className="flexColumn itemContainerimg">
            <img
              alt="Org-Img"
              className={`Icon60 Org-Img ${OrgImg ? "" : "color-white-icon"}`}
              src={OrgImg ? OrgImg : GetImages.HomeBlackFilled}
            />
          </div>
          <div className="flexColumn itemContainerimgDetail">
            <p className={headerNameClass}>
              {OrgName}
              {status && <span className={statusClass}>{status}</span>}
            </p>
            {SubHeaderName && showDivider && <hr />}
            {statusElement && statusElement}
            <p className={subHeaderNameClass}>{SubHeaderName}</p>
          </div>
        </div>
        <div className="onboardtopbar_right ">{element}</div>
      </div>
    </>
  );
};

export default OrganizationNameHeader;
